import React from 'react';
import { ListView } from './list-view';
import { GridView } from './grid-view';
import { jsx as _jsx } from "react/jsx-runtime";
export const VisibleStores = _ref => {
  let {
    centre,
    stores,
    storesView,
    onClick
  } = _ref;
  const StoresView = storesView === 'LIST' ? ListView : GridView;
  return /*#__PURE__*/_jsx(StoresView, {
    centre: centre,
    stores: stores,
    onClick: onClick,
    "data-id": "visible-stores_index_VisibleStores_StoresView"
  });
};